import React, { Component } from 'react'
import { connect } from 'react-redux'
import { identity } from 'lodash'
import classNames from 'classnames'

import { getFinishVM } from 'state/viewModels'
import * as actions from 'ducks/modules/customize'
import NavWarning from 'containers/NavWarning'
import { TrackedButtonLink } from 'components/Buttons'
import Price from 'components/Price'

export class FinishForm extends Component {

  render = () => (<div>
    <div className="customize-form-header">Finish & Paintfill</div>
    <div className="customize-form-section">
      
      {this.props.options
        .map(option => (
          <div key={option.type + option.id} className="side-radio">
            <label style={{ display: 'block' }} className={"radio-select " + ((this.props.selected && this.props.selected.id === option.id) ? 'option-selected' : '')}>
              <div className={((this.props.selected && this.props.selected.id === option.id) ? 'option-selected ' : '') + "radio-target"} ></div>
              <input type="radio" name="finishPaintfill"
                value={option.id}
                onChange={(evt) => { this.props.onSelectField(option.type, evt.target.value); }}
                checked={!!(this.props.selected) && option.id === this.props.selected.id}
              />
              {option.label}
              {!(this.props.buyAPutter && this.props.buyAPutter.selected) &&
                <Price value={option.price} />
              }
            </label>
            {/*If refinish or restoration is selected, then show finish options*/}
            {//(option.type === 'refinish' || option.type === 'restorationType') && !!(this.props.selected) && (this.props.selected.type === option.type) &&
            }
            {option.type === 'restorationType' && !!(this.props.selected) && (this.props.selected.type === option.type) &&
              <div className="customize-form-section-content restoration">
                  <div className={"restoration-text " + (this.props.selected.type === option.type ? 'option-selected' : '')}>Includes re-milling, refinish, paintfill, shaft, shaft band, grip and headcover.</div>
                  {this.props.finish.options.map(finish => (
                    <div key={finish.id} className="side-radio">
                      <label style={{ display: 'block' }} className={"radio-select " + classNames({
                        'option-selected':this.props.finish.selected && finish.id === this.props.finish.selected.id,
                        'error': this.props.showValidationWarnings && (!this.props.finish.valid),
                      })}>
                        <div className={(this.props.finish.selected && finish.id === this.props.finish.selected.id ? 'option-selected ' : '') + "radio-target"} ></div>
                        <input type="radio" name="finish"
                          value={finish.id}
                          onChange={(evt) => { this.props.onSelectField('finish', evt.target.value); }}
                          checked={!!(this.props.finish.selected) && finish.id === this.props.finish.selected.id}
                        />
                        {finish.label} Finish (no charge)
                      </label>
                    </div>
                  ))}
                  <div className="clearfix"></div>
              </div>
            }
          </div>
      ))}
    </div>
    <div className="customize-form-section">
      <TrackedButtonLink trackingData="Next:Face" className="next" to="face">next: face</TrackedButtonLink>
    </div>
    <NavWarning when={!this.props.validation.valid}
        message="Please complete all selections above before going to another page." />
  </div>)
}

FinishForm.defaultProps = {
  onSelectField: identity,
};

const mapStateToProps = (state, ownProps) => {
  var p = { ...getFinishVM(state.customize) }
  p.showValidationWarnings = state.app.blockedNavigation && !p.validation.valid
  return p;
}
const mapDispatchToProps = {
  onSelectField: actions.selectField,
  resetPaintFills: actions.resetPaintFills,
}

export default connect(mapStateToProps, mapDispatchToProps)(FinishForm);

